import { SidebarModalWrapperMobile } from 'components/site/modals/SidebarModalWrapper/SidebarModalWrapperMobile';
import { SidebarModalWrapperPc } from 'components/site/modals/SidebarModalWrapper/SidebarModalWrapperPc';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';

interface Props {
    className?: string;
    content: JSX.Element;
    footer?: JSX.Element;
    background?: string;
    onClose: () => void;
}

export const SidebarModalWrapper = (props: Props): JSX.Element => {
    const isWide = useIsWide();

    if (!isWide) {
        return (
            <SidebarModalWrapperMobile
                content={props.content}
                footer={props.footer}
                onClose={props.onClose}
                background={props.background}
            />
        );
    } else {
        return (
            <SidebarModalWrapperPc
                content={props.content}
                footer={props.footer}
                onClose={props.onClose}
                background={props.background}
            />
        );
    }
};
